import * as React from "react";
import styles from "./ContentWithMaxWidth.module.css";

interface Props {
  children: React.ReactNode;
}

export const ContentWithMaxWidth: React.FC<React.PropsWithChildren<Props>> = ({
  children,
}) => <div className={styles.container}>{children}</div>;
